module.exports = __webpack_public_path__ + "static/ring.07a06542.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/ring.png
// module id = 447
// module chunks = 168707334958949